import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import backButton from "./Images/back.png";

const Sphere = () => {
  const userEmail = sessionStorage.getItem("userEmail");
  const navigate = useNavigate();

  const [folderName, setFolderName] = useState("default");
  const [sphereUrl, setSphereUrl] = useState("");
  const [glbUrl, setGlbUrl] = useState("");
  const [inputs, setInputs] = useState({ radius: "" });

  // Redirect if not logged in
  useEffect(() => {
    if (!userEmail) navigate("/signin");
  }, [userEmail, navigate]);

  // Inject <model-viewer> once
  useEffect(() => {
    if (!document.querySelector("script#model-viewer")) {
      const script = document.createElement("script");
      script.id = "model-viewer";
      script.type = "module";
      script.src = "https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js";
      document.head.appendChild(script);
    }
  }, []);

  // Fetch folder name from backend
  useEffect(() => {
    const fetchFolderName = async () => {
      try {
        const response = await fetch("https://www.d-rosa.ai/appname");
        const data = await response.json();
        setFolderName(data.foldername || "default");
      } catch (error) {
        console.error("Error fetching folder name:", error);
      }
    };
    fetchFolderName();
  }, []);

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  // Generate Sphere STEP file
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://www.d-rosa.ai/spheredesign", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          file_path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`,
          user_email: userEmail,
          folder_path: folderName,
          radius: parseInt(inputs.radius),
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setSphereUrl(data.sphereurl || "");
        alert("Sphere design is completed!!");
      } else {
        console.error("Error sending sphere data");
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }
  };

  // Convert STEP ? GLB and display
  const handleView = async () => {
    try {
      const response = await fetch("https://www.d-rosa.ai/SpheretoGlbb", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          file_path: `/var/www/myflaskapp/flask_static/${userEmail}/${folderName}`,
          user_email: userEmail,
          folder_path: folderName,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        setGlbUrl(data.glburl || "");
      } else {
        console.error("Error converting Sphere to GLB");
      }
    } catch (error) {
      console.error("Error in handleView:", error);
    }
  };

  return (
    <div id="image-container">
      <center>
        <h2 className="center-heading">Sphere Design</h2>
      </center>

      <p>Signed in as: {userEmail}</p>

      <form onSubmit={handleSubmit}>
        <input
          type="number"
          name="radius"
          value={inputs.radius}
          onChange={handleChange}
          placeholder="Radius"
          className="w-full p-2 border rounded"
          required
        />
        <br /><br />
        <button type="submit">Submit</button>
      </form>

      <br />
      <p>Sphere File Path: {sphereUrl}</p>

      {sphereUrl && (
        <>
          <a href={sphereUrl} target="_blank" rel="noopener noreferrer">
            <button style={{ padding: "10px 20px", fontSize: "16px" }}>
              Download
            </button>
          </a>
          <br /><br />
          <button
            onClick={handleView}
            style={{ padding: "10px 20px", fontSize: "16px" }}
          >
            View
          </button>
        </>
      )}

      {/* Show GLB in model-viewer */}
      {glbUrl && (
        <div style={{ marginTop: "20px" }}>
          <h3>3D Sphere Model</h3>
          <model-viewer
            src={glbUrl}
            alt="Sphere model"
            auto-rotate
            camera-controls
            ar
            shadow-intensity="1"
            style={{ width: "600px", height: "400px", backgroundColor: "green" }}
          ></model-viewer>
        </div>
      )}

      <br />
      <button onClick={() => navigate("/previous-page")}>
        <img src={backButton} alt="Back" width="60" height="60" />
      </button>

      <footer className="footer-section">
        <div className="text-6">
          &copy; 2022 HYDAX Hydraulics Pvt. Ltd. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default Sphere;
